import { createRoute, lazyRouteComponent, stripSearchParams } from '@tanstack/react-router'
import type { PlayerSort } from '@volee/api-client'

import { requireBackoffice } from '../auth/guard.ts'
import { parseOneOf, parsePage, parseQuery } from './params.ts'
import { rootRoute } from './root.tsx'

// Everyone who plays: the register you search when you do not know whose player they are.
// The endpoint also filters by club, and no screen produces that — so neither does this.

export interface PlayerSearch {
  /** 1-based: it is the number a person shares. */
  readonly page: number
  readonly q: string | null
  readonly sort: PlayerSort
}

const SORTS: readonly PlayerSort[] = ['last_name', '-last_name', 'birth_date', '-birth_date']

export const DEFAULT_PLAYER_SORT: PlayerSort = 'last_name'

export const DEFAULT_PLAYER_SEARCH: PlayerSearch = {
  page: 1,
  q: null,
  sort: DEFAULT_PLAYER_SORT,
}

export function parsePlayerSort(value: unknown): PlayerSort {
  return parseOneOf(SORTS, value) ?? DEFAULT_PLAYER_SORT
}

/** The list as a link target: path and the search params its type requires, in one place. */
export const playerListLink = { to: '/players', search: DEFAULT_PLAYER_SEARCH } as const

export const playersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/players',
  validateSearch: (search: Record<string, unknown>): PlayerSearch => ({
    page: parsePage(search.page),
    q: parseQuery(search.q),
    sort: parsePlayerSort(search.sort),
  }),
  search: {
    middlewares: [stripSearchParams(DEFAULT_PLAYER_SEARCH)],
  },
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/players.tsx')),
})
